const channel_campaign_group_sales_period_type_options = [
  { label: "Niski", value: "low" },
  { label: "Wysoki", value: "high" },
];

export const getChannelCampaignGroupSalesPeriodType = (val) =>
  channel_campaign_group_sales_period_type_options.find(
    ({ value }) => value === val,
  )?.label;

export default channel_campaign_group_sales_period_type_options;
